module.exports = __webpack_public_path__ + "img/info-02.6f1f15a9.png";